import React from 'react';
import { Button } from '@sm/wds-react';
import './action-group.scss';

const ActionGroup = () => {
  return (
    <div className="sm-action-group--container">
      <div className="sm-action-group--cta">
        <Button size="lg">Done</Button>
      </div>
    </div>
  );
};

export default ActionGroup;
